module.exports = __webpack_public_path__ + "img/mobile.3aba4926.png";